module.exports = {
    devServer: {
        disableHostCheck: false,
        proxy: {
            '^/pdm_webapp/profile/*' :{
                target: 'https://id2179.chrmayr.lan:8443', //Hier Adresse des lokalen Backends eintragen
                changeOrigin: true
            },
            '^/pdm_webapp/standard/*' :{
                target: 'http://localhost:8080',
                changeOrigin: true
            },
            '^/pdm_webapp/cache/reset/*' :{
                target: 'http://localhost:8080',
                changeOrigin: true
            },
            '^/pdm_webapp/loadType3d/*' :{
                target: 'http://localhost:8080',
                changeOrigin: true
            },
            '^/pdm_webapp/restoverview/*' :{
                target: 'http://localhost:8080',
                changeOrigin: true
            },
            '^/pdm_webapp/overviewByKonfigModel/*' :{
                target: 'http://localhost:8080',
                changeOrigin: true
            },
            '^/pdm_webapp/static/*' :{
                target: 'http://localhost:8080',
                changeOrigin: true
            },
            '^/pdm_webapp/pictures/*' :{
                target: 'http://localhost:8080',
                changeOrigin: true
            },
            '^/pdm_webapp/produktAuswahl/*' : {
                target: 'http://localhost:8080',
                changeOrigin: true
            },
            '^/pdm_webapp/direct_access/*' : {
                target: 'http://localhost:8080',
                changeOrigin: true
            },
            '^/pdm_webapp/overview*' : {
                target: 'http://localhost:8080',
                changeOrigin: true
            },
            '^/pdm_webapp/search*' : {
                target: 'http://localhost:8080',
                changeOrigin: true
            },
            '^/pdm_webapp/products/search/*' : {
                target: 'http://localhost:8080',
                changeOrigin: true
            },
            '^/pdm_webapp/vorzugswerte/*' : {
                target: 'http://localhost:8080',
                changeOrigin: true
            },
            '^/pdm_webapp/configuration**' : {
                target: 'http://localhost:8080',
                changeOrigin: true
            },
            '^/pdm_webapp/expert*' : {
                target: 'http://localhost:8080',
                changeOrigin: true
            },
            '^/pdm_webapp/specialOverview*' : {
                target: 'http://localhost:8080',
                changeOrigin: true
            },
            '^/pdm_webapp/backToStandardConfig*' : {
                target: 'http://localhost:8080',
                changeOrigin: true
            },
            '^/pdm_webapp/specialText*' : {
                target: 'http://localhost:8080',
                changeOrigin: true
            },
            '^/pdm_webapp/saveSonderteil*' : {
                target: 'http://localhost:8080',
                changeOrigin: true
            },
            '^/pdm_webapp/downloadDrawing*' : {
                target: 'http://localhost:8080',
                changeOrigin: true
            },
            '^/pdm_webapp/drawing*' : {
                target: 'http://localhost:8080',
                changeOrigin: true
            },
            '^/pdm_webapp/productText*' : {
                target: 'http://localhost:8080',
                changeOrigin: true
            },
            '^/pdm_webapp/productTreeVue/*' : {
                target: 'https://id2179.chrmayr.lan:8443', //TODO
                changeOrigin: true
            }


        }
    },
    publicPath: '/pdm_webapp',
    pluginOptions: {
        i18n: {
            locale: 'en',
            fallbackLocale: 'en',
            localeDir: 'locales',
            enableInSFC: true
        }
    },
    chainWebpack: config => {
        config.module
            .rule('vue')
            .use('vue-loader')
            .loader('vue-loader')
            .tap(options => {
                options.transformAssetUrls = {
                    img: 'src',
                    image: 'xlink:href',
                    'b-avatar': 'src',
                    'b-img': 'src',
                    'b-img-lazy': ['src', 'blank-src'],
                    'b-card': 'img-src',
                    'b-card-img': 'src',
                    'b-card-img-lazy': ['src', 'blank-src'],
                    'b-carousel-slide': 'img-src',
                    'b-embed': 'src'
                }
                return options
            })
    }
}